import main from "@/main";

export default function (to, from, savedPosition) {
  if(to.params.savedPosition) return null
  return new Promise(resolve => {
    main.$root.$once("beforeEnter", () => {
      if (savedPosition) {
        resolve(savedPosition);
      } else {
        resolve({ x: 0, y: 0 });
      }
    });
  });
}
